/**
 * @generated SignedSource<<729c72a720a7cbbf2d19347bf953393a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddJiraInstanceInput = {
  apiKey?: string | null | undefined;
  clientId?: string | null | undefined;
  clientSecret?: string | null | undefined;
  issueLimitHard?: number | null | undefined;
  issueLimitSoft?: number | null | undefined;
  name?: string | null | undefined;
  url: string;
  username?: string | null | undefined;
};
export type AddJiraInstanceMutation$variables = {
  input: AddJiraInstanceInput;
};
export type AddJiraInstanceMutation$data = {
  readonly addJiraInstance: {
    readonly jiraInstance: {
      readonly clientId: string | null | undefined;
      readonly defaultSpace: {
        readonly key: string;
        readonly name: string;
      } | null | undefined;
      readonly defaultWorkType: {
        readonly name: string;
      } | null | undefined;
      readonly error: string | null | undefined;
      readonly id: string;
      readonly issueLimitHard: number;
      readonly issueLimitSoft: number;
      readonly name: string | null | undefined;
      readonly spaces: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"JiraInstanceDefaultsFields_spaces">;
      }>;
      readonly spacesUpdated: string | null | undefined;
      readonly updatePending: boolean;
      readonly url: string;
      readonly username: string | null | undefined;
      readonly uuid: any;
    } | null | undefined;
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type AddJiraInstanceMutation = {
  response: AddJiraInstanceMutation$data;
  variables: AddJiraInstanceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraSpace",
  "kind": "LinkedField",
  "name": "defaultSpace",
  "plural": false,
  "selections": [
    (v3/*:: as any*/),
    (v4/*:: as any*/)
  ],
  "storageKey": null
},
v6 = [
  (v4/*:: as any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraWorkType",
  "kind": "LinkedField",
  "name": "defaultWorkType",
  "plural": false,
  "selections": (v6/*:: as any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueLimitHard",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueLimitSoft",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spacesUpdated",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatePending",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddJiraInstanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "AddJiraInstancePayload",
        "kind": "LinkedField",
        "name": "addJiraInstance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JiraInstance",
            "kind": "LinkedField",
            "name": "jiraInstance",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v5/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraSpace",
                "kind": "LinkedField",
                "name": "spaces",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "JiraInstanceDefaultsFields_spaces"
                  }
                ],
                "storageKey": null
              },
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v17/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AddJiraInstanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "AddJiraInstancePayload",
        "kind": "LinkedField",
        "name": "addJiraInstance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JiraInstance",
            "kind": "LinkedField",
            "name": "jiraInstance",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v5/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraSpace",
                "kind": "LinkedField",
                "name": "spaces",
                "plural": true,
                "selections": [
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraWorkType",
                    "kind": "LinkedField",
                    "name": "workTypes",
                    "plural": true,
                    "selections": (v6/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v17/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d72303a9cb294b8c3696dea2c510f2fc",
    "id": null,
    "metadata": {},
    "name": "AddJiraInstanceMutation",
    "operationKind": "mutation",
    "text": "mutation AddJiraInstanceMutation(\n  $input: AddJiraInstanceInput!\n) {\n  addJiraInstance(input: $input) {\n    jiraInstance {\n      clientId\n      defaultSpace {\n        key\n        name\n      }\n      defaultWorkType {\n        name\n      }\n      error\n      id\n      issueLimitHard\n      issueLimitSoft\n      name\n      spaces {\n        ...JiraInstanceDefaultsFields_spaces\n      }\n      spacesUpdated\n      updatePending\n      url\n      username\n      uuid\n    }\n    problems {\n      __typename\n      message\n    }\n  }\n}\n\nfragment JiraInstanceDefaultsFields_spaces on JiraSpace {\n  key\n  name\n  workTypes {\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "71c94afea57828ff5b1d1836cf955be0";

export default node;
